module.exports = {"development":{"apiKey":"AIzaSyBRyMppV1NPiaodYqOhx_ENQYNVbDOSuQU","authDomain":"serrano-dev.firebaseio.com","messagingSenderId":"452608249201"},"homologacao":{"apiKey":"AIzaSyAwKSAlvmEoTOqqXSdvZUI1mzrARKsPrdA","authDomain":"serrano-vlance-homo.firebaseio.com","messagingSenderId":"417038769987"},"production":{"apiKey":"AIzaSyBEKpQs4cZPBch-7NHXM5sSkOt62qiigh4","authDomain":"serrano-vlance.firebaseio.com","messagingSenderId":"804755193614"}}


//////////////////
// WEBPACK FOOTER
// ./config/configuracao-Firebase.json
// module id = CXWA
// module chunks = 1